import { render, staticRenderFns } from "./ApplicantNote.vue?vue&type=template&id=1f73d673&scoped=true&"
import script from "./ApplicantNote.vue?vue&type=script&lang=js&"
export * from "./ApplicantNote.vue?vue&type=script&lang=js&"
import style0 from "./ApplicantNote.vue?vue&type=style&index=0&id=1f73d673&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f73d673",
  null
  
)

export default component.exports